import type { HelpCenterArticleLinks } from "./help-center.type";

export const HELP_CENTER_URL =
  "https://stelar.atlassian.net/servicedesk/customer/portals";

export const HELP_CENTER_LINKS: HelpCenterArticleLinks = {
  technicalForm: {
    fr: "https://stelar.atlassian.net/servicedesk/customer/portal/4/article/833781761",
    en: "https://stelar.atlassian.net/servicedesk/customer/portal/4/article/837976065",
  },
};
